import React from 'react';

export interface MappingTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

/**
 * Tab panel used inside the mapping workspace (and other workspace tabs).
 *
 * Provides the full-height, overflow-hidden flex container that each tab
 * page expects. Keeps tab panel layout consistent across Mapping,
 * Quick Fill, Validation, and Export.
 */
export const MappingTabPanel: React.FC<MappingTabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tab-${index}`}
    style={{
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      display: value === index ? 'flex' : 'none',
      flexDirection: 'column',
      overflow: 'hidden',
      boxSizing: 'border-box',
      minWidth: 0,
      minHeight: 0,
      flex: value === index ? 1 : undefined,
    }}
    {...other}
  >
    {value === index && children}
  </div>
);

export default MappingTabPanel;
